// @flow

import React, { PureComponent } from 'react';
import Translate from 'client/components/translate';
import { currency } from 'client/utils/format';

type Props = {
  price: number | string,
  precision?: number,
  content?: string,
  classes: {
    colorClass: string,
    iconClass: string,
  },
};

export default class Price extends PureComponent<Props> {
  static defaultProps = {
    price: '',
    content: '',
    classes: {
      colorClass: '',
      iconClass: '',
    },
    precision: 0,
  };

  render() {
    const { content, price, classes, precision } = this.props;

    return (
      <div className="price neutral-text-color">
        <div className="flex-row">
          <span className={`${classes.colorClass} flex-row accessible`}>
            {classes.iconClass && (
              <span>
                <span style={{ fontSize: '1.3em' }} className={`${classes.iconClass} flush-left`} />
              </span>
            )}

            <span>{currency(price, precision)}</span>
          </span>
          &nbsp;
          <span style={{ fontWeight: 'lighter' }}>
            <Translate path={content} />
          </span>
        </div>
      </div>
    );
  }
}
